import React, { useEffect, useState } from "react";
import { Table, Button, Input, Modal } from "antd";
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import "../../styles/commonComponents/TableMaker.scss";

const TableMaker = ({ data, update, remove }) => {
    const [searchText, setSearchText] = useState("");
    const [tableData, setTableData] = useState(data || []);
    useEffect(() => {
        setTableData(data || []);
    }, [data]);
    if (!tableData || tableData.length === 0) {
        return <p>No data available</p>;
    }

    // Dynamically create columns from data keys
    const dataKeys = Object.keys(tableData[0]);

    const columns = dataKeys.map((key) => {
        const uniqueValues = [...new Set(tableData.map((item) => item[key]))].filter(
            (val) => val !== undefined && val !== null
        );

        return {
            title: key.charAt(0).toUpperCase() + key.slice(1),
            dataIndex: key,
            key: key,
            filters:
                uniqueValues.length > 1
                    ? uniqueValues.map((val) => ({ text: String(val), value: val }))
                    : null,
            onFilter: (value, record) => String(record[key]).includes(value),
            sorter: (a, b) => {
                if (typeof a[key] === "number" && typeof b[key] === "number") {
                    return a[key] - b[key];
                }
                return String(a[key]).localeCompare(String(b[key]));
            },
        };
    });

    // Add action column
    columns.push({
        title: "Actions",
        key: "actions",
        render: (_, record) => (
            <div className="action-buttons">
                <Button
                    color="primary"
                    variant="outlined"
                    className="admin-action-btn update-btn"
                    onClick={() => update(record.id)}
                >
                    <FaEdit />
                </Button>
                <Button
                    danger
                    className="admin-action-btn remove-btn"
                    onClick={() => {
                        Modal.confirm({
                            title: "Are you sure you want to delete this item?",
                            content: "This action cannot be undone.",
                            okText: "Yes, delete",
                            okType: "danger",
                            cancelText: "Cancel",
                            onOk: async () => {
                                try {
                                    await remove(record.id); // call API
                                    setTableData((prev) =>
                                        prev.filter((item) => item.id !== record.id)
                                    ); // update local table
                                } catch (err) {
                                    console.error("Delete failed:", err);
                                }
                            },
                        });
                    }}
                >
                    <MdDelete />
                </Button>
            </div>
        ),
    });

    // Global search filter
    const filteredData = tableData.filter((item) =>
        Object.values(item).some((val) =>
            String(val).toLowerCase().includes(searchText.toLowerCase())
        )
    );

    const onChange = (pagination, filters, sorter, extra) => {
        console.log("params", pagination, filters, sorter, extra);
    };

    return (
        <div className="table-container">
            {/* 🔍 Search bar */}
            <Input.Search
                placeholder="Search..."
                allowClear
                onChange={(e) => setSearchText(e.target.value)}
                style={{ marginBottom: 16, width: 300 }}
            />

            <Table
                dataSource={filteredData.map((item) => ({ ...item, key: item.id }))}
                columns={columns}
                pagination={{ pageSize: 5 }}
                bordered
                onChange={onChange}
            />
        </div>
    );
};

export default TableMaker;
